import type { Loch } from '@/app/lib/types';
import { PlaceHolderImages } from '@/lib/placeholder-images';

// Simple in-memory cache
let cachedLochs: Loch[] | null = null;

const placeholderImageIds = PlaceHolderImages.map(p => p.id);

function getRandomPlaceholderId() {
    return placeholderImageIds[Math.floor(Math.random() * placeholderImageIds.length)];
}

async function fetchAllLochs(): Promise<Loch[]> {
  if (cachedLochs) {
    return cachedLochs;
  }

  try {
    const response = await fetch('https://ai-travel-itinerary-ai-228543204937.europe-west2.run.app/api/get_lochs');
    if (!response.ok) {
      throw new Error(`Failed to fetch lochs: ${response.statusText}`);
    }
    const data: any[] = await response.json();
    
    const supplementedData = data.map(loch => ({
      ...loch,
      slug: loch.id,
      name: loch['Loch Name'],
      region: loch['County/Region'],
      description: `A beautiful loch near ${loch.NearestPlace}.`,
      details: loch.ValidationNotes,
      access: 'Publicly accessible',
      water_quality: 'Good' as const,
      rating: 4.0 + Math.random(), // Random rating between 4.0 and 5.0
      imageId: getRandomPlaceholderId(),
    }));


    cachedLochs = supplementedData;
    return supplementedData;
  } catch (error) {
    console.error(error);
    // Return an empty array or re-throw, depending on desired error handling
    return [];
  }
}

export async function getLochBySlug(slug: string): Promise<Loch | undefined> {
  const allLochs = await fetchAllLochs();
  return allLochs.find(loch => loch.slug === slug);
}
